<template>
  <div class="machineListTip" :class="{ parameter: isParameter }">
    <div class="tip-title">
      {{ machineName }}
      <div class="close" @click="closeFn" v-if="closeShow"></div>
    </div>
    <el-checkbox-group
      @change="checkChangeFn"
      v-model="machineList"
      :max="maxCheck"
      :min="minCheck"
    >
      <el-checkbox v-for="v in machineListInfo" :label="v" :key="v.key">
        {{ v.filedName }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
import {isChooseUpdate } from "@/assets/api/chartData";
export default {
  props: {
    isParameter: {
      type: Boolean,
      default: false,
    },
    closeShow: {
      type: Boolean,
      default: true,
    },
    maxCheck: {
      type: Number,
      default: 3,
    },
    minCheck: {
      type: Number,
      default: 1,
    },
    machineData: {
      type: Object,
      default: {},
    },
    machineTipKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      machineName: "",
      // 全部
      machineListInfo: [],
      // 选中
      machineList: [],
      // 机器key
      machineListKey: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.machineListKey = this.machineTipKey;
      this.machineName = this.machineData.machineName;
      this.machineListInfo = this.machineData.filedVoList;
      // this.machineList = this.machineData.filedVoList.filter((v) => {
      //   if (v.isChoose > 0) {
      //     return v.filedKey;
      //   }
      // });
    });
  },
  methods: {
    // 点击关闭按钮
    closeFn() {
      this.$emit("child-closeFn");
    },
    // 复选框
    checkChangeFn(e) {
      // 把类型全部设置为0
      this.machineListInfo.map((v) => (v.isChoose = 0));
      // 拿出key
      let checkArr = e.map((v) => v.filedKey);
      // 包含key值的赋 1
      this.machineListInfo.map((v) => {
        if (checkArr.includes(v.filedKey)) {
          v.isChoose = 1;
        }
        return v;
      });
      // 修改后数据
      let changeData = {
        name: this.machineListKey,
        list: this.machineListInfo,
      };
      isChooseUpdate(changeData.list).then(res=>{
        // console.log(res);
      })
    },
  },
};
</script>
<style lang="less" scoped>
.machineListTip {
  width: 200px;
  height: 230px;
  background: url("./images/machineListTip-bg.png") no-repeat 0 0;
  background-size: 100% 100%;

  .tip-title {
    width: 100%;
    height: 32px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: url("./images/machineListTip-title.png") no-repeat 0 0;
    background-size: 100%;
    border: 1px solid;
    border-image: linear-gradient(
        243deg,
        rgba(223, 242, 255, 0),
        rgba(255, 255, 255, 1)
      )
      1 1;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;

    .close {
      width: 14.4px;
      height: 12.8px;
      background: url("./images/close.png") no-repeat 0 0;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}

.parameter {
  height: 360px;
}
</style>

<style lang="less">
.machineListTip {
  .el-checkbox-group {
    height: calc(100% - 36px);
    padding-top: 5px;
    padding-left: 12px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: left;
    line-height: 28px;

    .el-checkbox {
      .el-checkbox__input {
        width: 16px;
        height: 16px;

        .el-checkbox__inner {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0);
          border-color: #32c5ff;
        }

        .el-checkbox__inner::after {
          border: 2px solid #fff;
          border-left: 0;
          border-top: 0;
          left: 5px;
        }
      }

      .is-checked {
        .el-checkbox__inner {
          background: #32c5ff;
        }
      }

      .is-disabled {
        .el-checkbox__inner {
          background: #999;
          border: 0;
        }
      }

      .is-disabled + .el-checkbox__label {
        color: #999;
      }

      .el-checkbox__label {
        font-size: 12px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }
}
</style>